/* eslint-disable indent */
import { Button, Dialog, DialogContent, Divider, Grid, Icon } from '@mui/material'
import { POINT_STATUS_DECLARATION } from 'agriAdministration/constants/AgriConstants'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import PropTypes from 'prop-types'
import React from 'react'
import i18n from 'simple-react-i18n'

const ModalRemovePoint = ({ open, pointStatus, onCancel, onDeclareUnused, onDeclareAdjourn, onDeclareUsed, onRemovePoint }) => (
    <Dialog
        maxWidth='md'
        open={open}
        slotProps={{
            paper: {
                sx: {
                    minHeight: 'auto',
                    maxHeight: 'auto',
                },
            },
        }}
    >
        <DefaultDialogTitle title={i18n.changeStatusPoint} onClose={onCancel} />
        <DialogContent className='padding-bottom-0'>
            <Grid
                container
                direction='column'
                justifyContent='center'
                alignItems='center'
                style={{ height: '100%', padding: '10px' }}
            >
                <Grid>
                    <Button
                        variant='contained'
                        color='primary'
                        onClick={onDeclareUnused}
                        startIcon={<Icon style={{ marginRight: 8 }}>invert_colors_off</Icon>}
                    >
                        {i18n.declareUnused}
                    </Button>
                </Grid>
                <Grid>
                    <p style={{ padding: '0 10px', textAlign: 'center' }}>Le point de prélèvement sera déclaré comme non utilisé pour la présente déclaration, mais il reste bien rattaché à votre dossier.<br/>Si des usages ont été saisis, ils seront supprimés.</p>
                </Grid>
                <Divider className='margin-bottom-1' style={{ width: '100%' }} />
                <Grid>
                    <Button
                        variant='contained'
                        color='primary'
                        onClick={pointStatus === POINT_STATUS_DECLARATION.ADJOURNED ? onDeclareUsed : onDeclareAdjourn}
                        startIcon={<Icon style={{ marginRight: 8 }}>{pointStatus === POINT_STATUS_DECLARATION.ADJOURNED ? 'invert_colors' : 'access_time'}</Icon>}
                    >
                        {pointStatus === POINT_STATUS_DECLARATION.ADJOURNED ? i18n.declareUsed : i18n.declareToAdjourn}
                    </Button>
                </Grid>
                <Grid>
                    <p style={{ padding: '0 10px', whiteSpace: 'pre-wrap', textAlign: 'center' }}>
                        {pointStatus === POINT_STATUS_DECLARATION.ADJOURNED ? 'Le point de prélèvement sera déclaré comme utilisé pour la présente déclaration.'
                            : ('Le point de prélèvement restera utilisé pour l\'année en cours, et passera en non utilisé pour l\'année prochaine. Il reste bien rattaché à votre dossier.\nSi des usages prévisionnels ont été saisis, ils seront supprimés.')}
                    </p>
                </Grid>
                <Divider className='margin-bottom-1' style={{ width: '100%' }} />
                <Grid>
                    <Button
                        variant='contained'
                        color='primary'
                        onClick={pointStatus === POINT_STATUS_DECLARATION.REMOVED ? onDeclareUsed : onRemovePoint}
                        startIcon={<Icon style={{ marginRight: 8 }}>{pointStatus === POINT_STATUS_DECLARATION.REMOVED ? 'invert_colors' : 'delete'}</Icon>}
                    >
                        {pointStatus === POINT_STATUS_DECLARATION.REMOVED ? i18n.declareUsed : i18n.closeSamplingPoint}
                    </Button>
                </Grid>
                <Grid>
                    <p style={{ padding: '0 10px', textAlign: 'center' }}>
                        {pointStatus === POINT_STATUS_DECLARATION.REMOVED ? 'Le point de prélèvement sera déclaré comme utilisé pour la présente déclaration.'
                            : 'Le point de prélèvement sera clôturé dans votre dossier et ne sera donc plus accessible via votre compte.'}
                    </p>
                </Grid>
            </Grid>
        </DialogContent>
    </Dialog>
)

ModalRemovePoint.propTypes = {
    pointStatus: PropTypes.number,
    onDeclareUsed: PropTypes.func,
    onDeclareUnused: PropTypes.func,
    onDeclareAdjourn: PropTypes.func,
    onRemovePoint: PropTypes.func,
    onCancel: PropTypes.func,
    open: PropTypes.bool,
}

export default ModalRemovePoint